(function () {
  /**
   * @ngdoc module
   * @name binky.core.contract.migrations
   * @description Module which defines contract-related migration models
   */
  angular.module('binky.core.contract.migrations', []);
})();
